import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCheckoutSummaryApi } from "../Apiservices/Auth/cart/Addtocart_api";

// -------------------------------
// INITIAL STATE
// -------------------------------
const initialState = {
  checkOutRequest: {
    event_id: null,
    priest: true,
    tent: true,
    catering: true,
    priest_pct: 100,
    tent_pct: 100,
    catering_pct: 100,
    coupon_code: "",
  },
  checkOutPageResponse: null,
  loading: false,
  refreshLoading: false,
};

// -------------------------------
// ASYNC ACTION (FIXED)
// -------------------------------
export const fetchCheckoutPage = createAsyncThunk(
  "checkout/fetch",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();

      // ✅ SAFE ACCESS (NO CRASH)
      const checkOutRequest = state.checkout?.checkOutRequest;

      if (!checkOutRequest) {
        console.error("❌ checkout state missing in store");
        return rejectWithValue("checkout state missing");
      }

      const res = await fetchCheckoutSummaryApi(checkOutRequest);
      console.log("Checkout API response:", res);

      if (res?.success) {
          return res.data;
        }

      console.log("Error Status")

      return null;
    } catch (err) {
      console.error("fetchCheckoutPage error", err);
      return rejectWithValue(err?.response?.data || err.message || "Error");
    }
  }
);

// -------------------------------
// SLICE
// -------------------------------
const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    // 🔹 CLEAR REQUEST
    clearCheckoutRequest: (state, action) => {
      const event_id = action.payload;

      state.checkOutRequest = {
        event_id,
        priest: true,
        tent: true,
        catering: true,
        priest_pct: 100,
        tent_pct: 100,
        catering_pct: 100,
        coupon_code: "",
      };

      console.log(state.checkOutRequest)
    },

    // 🔹 APPLY COUPON
    applyCoupon: (state, action) => {
      state.checkOutRequest.coupon_code = action.payload;
    },

    // 🔹 REMOVE COUPON
    removeCoupon: (state) => {
      state.checkOutRequest.coupon_code = "";
    },

    // 🔹 UPDATE SELECTIONS
    updatePriestSelection: (state, action) => {
      const { percentage } = action.payload;
      state.checkOutRequest.priest = percentage != null;
      state.checkOutRequest.priest_pct = percentage ?? 100;
    },

    updateTentSelection: (state, action) => {
      const { percentage } = action.payload;
      state.checkOutRequest.tent = percentage != null;
      state.checkOutRequest.tent_pct = percentage ?? 100;
    },

    updateCateringSelection: (state, action) => {
      const { percentage } = action.payload;
      state.checkOutRequest.catering = percentage != null;
      state.checkOutRequest.catering_pct = percentage ?? 100;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCheckoutPage.pending, (state) => {
        if (!state.checkOutPageResponse) {
          state.loading = true;
        } else {
          state.refreshLoading = true;
        }
      })
      .addCase(fetchCheckoutPage.fulfilled, (state, action) => {
        state.checkOutPageResponse = action.payload;
        state.loading = false;
        state.refreshLoading = false;
      })
      .addCase(fetchCheckoutPage.rejected, (state, action) => {
        console.error("Checkout fetch failed:", action.payload);
        state.checkOutPageResponse = null;
        state.loading = false;
        state.refreshLoading = false;
      });
  },
});

// -------------------------------
export const {
  clearCheckoutRequest,
  applyCoupon,
  removeCoupon,
  updatePriestSelection,
  updateTentSelection,
  updateCateringSelection,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;